var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AIButton } from '@web/components/layout/AIInsights/AIButton';
import { InformationCircle } from '@web/components/layout/InformationCircle/InformationCircle';
import { useTranslation } from 'react-i18next';
export var WidgetTitle = function (_a) {
    var title = _a.title, description = _a.description, insightType = _a.insightType, insightsData = _a.insightsData, refetch = _a.refetch, labels = _a.labels, csvExport = _a.csvExport;
    var t = useTranslation().t;
    return (_jsxs("div", __assign({ className: "flex items-center gap-2 mx-2 mb-4 justify-between" }, { children: [_jsxs("div", __assign({ className: "flex items-center mx-2 gap-2" }, { children: [_jsx("h3", __assign({ className: "text-xl font-semibold" }, { children: typeof title === 'string'
                            ? t(title)
                            : title })), _jsx(InformationCircle, { text: t(description) })] })), _jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [csvExport, _jsx(AIButton, { insightsData: insightsData || [], insightType: insightType, refetch: refetch, labels: labels })] }))] })));
};
